
























import { ref, defineComponent, useContext } from '@nuxtjs/composition-api'
import usePunchout from '~/composables/punchout/usePunchout'
import { usePdpStore } from '~/store/pdp'
import { usePDPNavigationObserver } from '~/composables/pdp/usePDPNavigationObserver'
import { COMPONENTS_IN_NAVIGATION } from '@/common/utils/product/constants'

export default defineComponent({
  props: {
    upstreamDownstreamPathwayImage: {
      type: Array as () => Object[],
      required: false,
      default: undefined,
    },
  },
  setup({ upstreamDownstreamPathwayImage }) {
    const { isPunchout } = usePunchout()
    const showAnchor = ref(false)
    const pathwayUrl = ref('')
    let dropdownData = [] as any[]

    const ctx = useContext()
    const isPreviewServer = ctx.$config.cst.isPreview

    const pdpStore = usePdpStore()
    const pathwaysRef = usePDPNavigationObserver(() => {
      pdpStore.setActiveComponentInNavigation(COMPONENTS_IN_NAVIGATION.PATHWAYS.ANCHOR)
    })

    if (upstreamDownstreamPathwayImage) {
      upstreamDownstreamPathwayImage.forEach((data: any) => {
        if (data.protein?.['pathway-urls']) {
          data.protein['pathway-urls'].forEach((pathway: any) => {
            dropdownData.push({
              pathName: pathway['path-name'],
              pathUrl: pathway['path-url'],
            })
          })
        }
      })
      dropdownData = [...new Map(dropdownData.map((item) => [item.pathName, item])).values()].sort((a, b) => {
        return a.pathName.localeCompare(b.pathName)
      })
    }

    const onChange = (event: any) => {
      if (event.target.value !== 'ALL') {
        showAnchor.value = true
        pathwayUrl.value = event.target.value
        window.open(event.target.value, '_blank')
      } else {
        showAnchor.value = false
      }
    }

    const displayCondition = ref(!!dropdownData.length && !isPunchout.value)
    if (displayCondition.value) {
      pdpStore.setComponentAsRendered(COMPONENTS_IN_NAVIGATION.PATHWAYS)
    }

    return {
      displayCondition,
      pathwaysRef,
      isPunchout,
      showAnchor,
      onChange,
      pathwayUrl,
      dropdownData,
      isPreviewServer,
    }
  },
})
